module.exports = __webpack_public_path__ + "img/clients-05.09d257d4.svg";